import React from "react";

export default function SlopeCross(props: any) {
  return (
    <svg className="map-slope-icon" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" {...props}>
      <circle cx="50" cy="50" r="35.45" fill="#944E98"></circle>
    </svg>
  );
}